export default __webpack_public_path__ + "static/media/dashboard.2008b4bf.svg";